import { DB_COST_LICENSING_NOTE, DB_RECOMMENDED_NOTE, RDS_COST_PENDING_NOTE, memoryText, resolveVm, vcpuText } from '@/data/sizeCatalog'
import { PoolTierSelector } from '@/components/common/PoolTierSelector'
import { formatCurrency } from '@/utils/format'

/**
 * What the RDS pool tiers mean for a product line (Traverse, Process Pro), under the product in Platform Config. Read-only: the four tiers,
 * their sessions and the fixed VMs are constants of the code (data/sizeCatalog.ts here, config/sizing.py in the backend), so there is nothing to
 * edit. It is the same set of cards the deployment wizard offers in Configure Sizes.
 */
export function ProductPoolTiers({ productId }: { productId: number }) {
  const rds = resolveVm('rds')
  const db = resolveVm('db')
  return (
    <div data-testid="product-pool-tiers" style={{ padding: '12px 16px 16px 40px', display: 'flex', flexDirection: 'column', gap: 10 }}>
      <span style={{ fontSize: '0.6875rem', fontWeight: 700, color: 'var(--aptean-text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        RDS pool tiers
      </span>
      <PoolTierSelector name={`admin-pool-tiers-${productId}`} legend="RDS pool tiers" />
      <p style={{ margin: 0, fontSize: 12, color: 'var(--aptean-text-muted)' }}>
        Every tier is built on the same RDS VM: <code>{rds.sku}</code> ({vcpuText(rds)}, {memoryText(rds)}, {rds.disk}); its price is not set yet ({RDS_COST_PENDING_NOTE.toLowerCase()}).
        The database VM is <code>{db.sku}</code> ({vcpuText(db)}, {memoryText(db)}, {db.disk}). {DB_RECOMMENDED_NOTE}. {DB_COST_LICENSING_NOTE}: {formatCurrency(db.estCostUsdPerMonth ?? 0)}/month.
        These are read-only: they are set in the code, and the portal and the pipeline use the same values.
      </p>
    </div>
  )
}
